
import Schema from 'AppReact/schema';
import { required } from 'AppReact/schema';

const range = {
  color: required('string'),
  text: required('string')
}
export default {
  ranges: Schema(range, 'array', { defaultValue: [] }),
  bordered: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  width: Schema('string', 'primitive-nullable', { defaultValue: null })
}

